module.exports = __webpack_public_path__ + "img/BF.2db515f3.png";